export default __webpack_public_path__ + "static/media/Aelfrith's Honour.821a8317.jpg";